export default {
    common: {
        no:"STT",
        actions: "Hành động",
        active: "Kích hoạt",
        add_success: "Thêm thành công!",
        add: "Thêm mới",
        admin_panel: "Trang Quản Trị",
        login: "Đăng Nhập",
        registerTitle: "Bạn chưa có tài khoản Yoclass.",
        registerDescription: "Hãy đăng ký là thành viên Yoclass!",
        register: "Đăng Ký",
        registerUse: "Đăng ký bằng",
        all: "Tất cả",
        apply: "Áp dụng",
        back: "Quay lại",
        cancel: "Hủy",
        close: "Đóng",
        complete: "Hoàn thành",
        configuration: "Cấu hình",
        continue: "Tiếp tục",
        create_at: "Tạo lúc",
        create_by: "Tạo bởi",
        create: "Tạo",
        date_filter: "Chọn khoảng thời gian",
        dateFormat: "DD/MM/YYYY",
        dateTimeFormat: "DD/MM/YYYY HH:mm",
        deleteConfirm: "Bạn có chắc muốn xóa?",
        delete_success: "Xoá thành công!",
        deleteError: "Xóa không thành công",
        delete: "Xoá",
        deleted: "Xoá {msg} thành công!",
        description: "Mô tả",
        design: "Thiết kế",
        detail: "Chi tiết",
        disabled: "Dừng kích hoạt",
        edit: "Sửa",
        enabled: "Đang kích hoạt",
        history: "Lịch sử",
        index: "Số thứ tự",
        input_filter: "Nhập để lọc",
        preview: "Xem trước",
        process: "Xử lý",
        profile: "Trang cá nhân",
        rows_per_page_text: "Số dòng: ",
        update: "Cập nhật",
        save: "Lưu",
        saveLink:"Lưu bài đăng",
        savedLink:"Bài đã lưu",
        unSaveLink:"Bỏ lưu",
        search: "Tìm kiếm",
        select_filter: "Lựa chọn",
        select_one: "Hãy chọn ít nhất một mục.",
        select: "Chọn",
        status: "Trạng thái",
        submit: "Thực hiện",
        sure: "Bạn chắc chứ?",
        type: "Thể Loại",
        save_success: "Lưu thành công",
        save_error: "Lưu không thành công",
        update_success: "Cập nhật thành công",
        confirm_success: "Xác nhận thành công",
        approve_success: "Phê duyệt thành công",
        validate_fail: "Kiểm tra không chính xác!",
        validate_form_fail: "Thông tin nhập không đầy đủ hoặc không chính xác!",
        use: "Item này đang được sử dụng. Xin hãy tạo item mới.",
        zoomin: "Phóng to",
        zoomout: "Thu nhỏ",
        zoomfit: "Vừa màn hình",
        clear: "Xóa",
        reorder: "Sắp xếp lại",
        notmatch: "Không chính xác",
        year: "Năm",
        permissionNotAllow: "Bạn không có quyền",
        loadmore: "Tải thêm",
        exportReport: "Xuất báo cáo",
        sendEmail: "Gửi Email",
        sendCode:"Gửi mã",
        code:"Mã xác thực",
        missFile: "Không tìm thấy file",
        uploadSuccess: "Upload thành công",
        uploadFailed: "Upload thất bại",
        chargeMoney: "Nạp tiền",
        offline: "Bạn bị mất kết nối, hãy kiểm tra lại kết nối",
        change: "Đổi",
        notfound: "Không tìm thấy thông tin",
        addnew:"Thêm mới",
        copy:"Sao chép",
        addReport:"Tạo báo cáo",
        createForm:"Thêm mới",
        lower: "{0} phải nhỏ hơn {1}",
        fromDate:"Từ ngày",
        toDate: "Đến ngày",
        startDate: "Ngày bắt đầu",
        endDate: "Ngày kết thúc",
        chose: "Chọn",
        note:"Ghi chú",
        reject:"Từ chối",
        check:"Kiểm tra",
        confirm:"Xác nhận",
        approve:"Phê duyệt",
        notApprove:"Không phê duyệt",
        reason:"Lý do",
        print:"In",
        return:"Quay lại",
        changePass:"Đổi mật khẩu",
        licenseEndDate: "Ngày hết hạn"
    },
    form: {
        title: "Quản lý mẫu biểu",
        add_edit: "Thêm mới/Sửa form",
        code: "Mã form",
        name: "Tên form"
    },
    footer: {
        title: "YoClass",
        copy: "Interland"
    },
    header: {
        title: "Quản lý tiến độ học tập Babilala"
    },
    menu: {
        list: "Danh sách menu"
    },
    route: {
        dashboard: "Bảng điều khiển"
    },
    search: {
        title: "Tìm kiếm văn bản",
        crawler: "Thu thập thông tin",
        input: "Nhập tìm kiếm",
        schema: "Lược đồ",
        tablename: "Tên bảng",
        columnname: "Tên cột",
        view_column: "Chi tiết các cột",
        index_table: "Lập chỉ mục bảng",
        index_all: "Đánh chỉ mục tất cả",
        upload_index: "Chỉ mục tệp",
        index_title: "Đánh chỉ mục",
    },
    setting: {
        title: "Thiết lập",
        menu_list: "D/sách menu"
    },
    task: {
        titleCompleted: "Công việc đã hoàn thành",
        title: "Quản lý công việc",
        taskname: "Công việc",
        assignnee: "Người được phân công",
        owner: "Người thực hiện",
        duedate: "Thời hạn hoàn thành",
        detail: "Chi tiết công việc",
        start: "Khởi tạo công việc",
        form: "Biểu mẫu",
        endtime: "Thời điểm kết thúc",
        duration: "Thời gian thực hiện",
        worktime: "Thời gian làm",
        durationFormat: "D ngày hh giờ: mm phút : ss giây",
        noformToView: "Task chưa được cấu hình form"
    },
    timeformat: {
        datetime_example: "Ví dụ định dạng ngày tháng",
        datetime_format: "Định dạng ngày tháng",
        time_example: "Ví dụ định dạng thời gian",
        time_format: "Định dạng thời gian",
        title: "Định dạng thời gian",
    },
    workflow: {
        title: "Quản lý luồng",
        code: "Mã luồng",
        name: "Tên luồng",
        add_edit: "Thêm mới / sửa luồng",
        edit_property: "Sửa thuộc tính",
        hide_property: "Ẩn bảng thuộc tính",
        show_property: "Hiển thị thuộc tính"
    },
    department: {
        code: "Mã bộ phận",
        name: "Tên bộ phận",
        address: "Địa chỉ",
        phone: "Điện thoại",
        email: "Email",
        parent: "Đơn vị cha",
        info: "Thông tin bộ phận",
        duplicateName: "Trùng tên bộ phận",
    },
    user: {
        title: "Người dùng",
        profile: "Thông tin người dùng",
        login: "Đăng nhập",
        forgotPassword:"Quên Mật Khẩu",
        username: "Tài khoản",
        phone: "Số điện thoại",
        fullName: "Họ và tên",
        oldPassword: "Mật khẩu hiện tại của bạn",
        password: "Mật khẩu của bạn",
        newPassword: "Mật khẩu mới của bạn",
        retypePassword: "Nhập lại mật khẩu của bạn",
        retypeNewPassword: "Nhập lại mật khẩu mới của bạn",
        email: "Email",
        birthday: "Ngày sinh",
        role: "Vai trò",
        registerRole:"Bạn tham gia với tư cách là",
        teacher: "Giáo viên",
        pupil: "Học viên",
        verify: "Xác thực",
        verifyCode: "Mã xác thực",
        verifyTitle: "Hãy nhập mã xác thực đã được gửi đến email/số điện thoại của bạn!",
        registerSuccess: "Đăng kí thành công",
        passwordNotMatch: "Mật khẩu không trùng nhau",
        passwordEmpty: "Mật khẩu để trống",
        duplicate: "Thông tin người dùng đã được đăng kí trước đó",
        emailDuplicate: "Email đã được đăng ký",
        emailExist: "Email đã tồn tại",
        usernameExist: "Tên tài khoản đã được sử dụng",
        contact: "Liên hệ",
        status: "Trạng thái",
        changePassword: "ĐỔI MẬT KHẨU",
        passwordNotCorrect: "Mật khẩu hiện tại không chính xác",
        yolearn:"Yolearn",
        zalo:"Zalo",
        reset:"Thiết lập lại",
        country: "Nước",
        materialType:"Nhóm vật tư",
        numberClass: "Số lớp tối đa"
    },
    role: {
        title: "Vai trò",
        roleName: "Tên vai trò",
        description: "Mô tả vai trò",
        active: "Hoạt động",
        permission: "Phân quyền",
        menu: "Chức năng",
        checkAll: "Chọn tất",
        accessLevel: "Mức độ truy cập",
        none: "Không",
        read: "Đọc",
        write: "Ghi",
        read_write: "Đọc và Ghi"
    },
    teacher: {
        name: "Tên giáo viên",
        workingAt: "Trường/trung tâm giảng dạy trên Yoclass",
        experience: "Số năm kinh nghiệm",
        objective: "Mục tiêu của bạn khi dùng YoClass",
        avatar: "Avatar",
        cv: "CV"
    },
    class: {
        title: "Lớp",
        welcome: "Chào mừng đến với Yoclass!<br> Hãy tạo lớp học đầu tiên của mình ngay nào!",
        empty_class_admin_teacher: "Bạn chưa có lớp học nào.<br> Tạo lớp học để sử dụng tính năng quản lý lớp học của Yoclass ngay bây giờ!",
        empty_class_student: "Tham gia lớp học Yoclass để Giáo viên thấy được sự tiến bộ của bạn ngay bây giờ!",
        empty: "Bạn chưa tham gia lớp nào",
        joinClass: "Tham gia lớp học",
        joined: "Bạn đã gia nhập lớp",
        createClass: "Tạo lớp học",
        classNotFound: "Mã lớp không tồn tại",
        className: "Tên lớp học",
        classCode: "Mã lớp học",
        subject: "Chủ đề",
        teacherName:"Giáo viên giảng dạy",
        schoolName:"Trường/trung tâm giảng dạy trên Yoclass",
        chapter:"Chương",
        grade: "Bậc học",
        discipline: "Môn học",
        description: "Giới thiệu lớp học",
        classInfo: "Thông tin lớp học của bạn",
        student: "Học viên",
        all: "Tất cả",
        lecture: "Bài giảng",
        exercise: "Bài tập",
        reference: "Tài liệu",
        members: "Thành viên",
        event: "Sự kiện",
        member: "Thành viên",
        joinSuccess: "Yêu cầu tham gia lớp học của bạn đã được gửi đến giáo viên và chờ phê duyệt",
        sendExercise:"Nộp bài",
        sendToStudent:"Giao bài",
        send: "Gửi",
        post: "Đăng",
        createQuiz: "Tạo bài tập trắc nghiệm",
        createEssay: "Tạo bài tập tự luận",
        waitAllow: "Phê duyệt",
        report: "Báo cáo",
        classBlock: "Khối/Lớp",
        library:"Thư viện",
    },
    category: {
        name: "Tên danh mục",
        code: "Mã danh mục",
        categoryTypeCode: "Mã loại danh mục",
        categoryTypeName: "Tên loại danh mục",
        description: "Mô tả",
        categoryManagement: "Quản lý các danh mục",
        categoryType: "Loại danh mục",
        createCategory: "Thêm danh mục",
        createCategoryType: "Tạo mới loại danh mục",
        subject: "Danh mục chủ đề",
        subjectCode: "Mã chủ đề",
        subjectName: "Tên chủ đề",
        createSubject: "Tạo chủ đề",
        degree: "Danh mục trình độ",
        degreeCode: "Mã trình độ",
        degreeName: "Tên trình độ",
        createDegree: "Tạo trình độ",
        discipline: "Danh mục môn học",
        disciplineCode: "Mã môn học",
        disciplineName: "Tên môn học",
        createDiscipline: "Tạo môn học",
        duplicateCode: "Trùng mã danh mục",
        duplicateName: "Trùng tên danh mục",
        similarTest: "Danh  mục dạng bài",
        similarTestCode: "Mã dạng bài",
        similarTestName: "Tên dạng bài",
        allItem: "",
    },
    //chuongbv
    program:{
        programType:"Khung chương trình",
        createProgramType:"Tạo mới khung chương trình",
        programCode:"Mã chương trình",
        programName:"Tên chương trình",
        description: "Mô tả",
        levelId:"Level",
        ageId:"Độ tuổi",
        weekTotal:"Số tuần học"
    },
    //end
    status: {
        active: "Hoạt động",
        notActive: "Chưa hoạt động"
    },
    feed: {
        pleasePost: "Chia sẻ đôi điều với lớp học",
        pleaseComment: "Viết bình luận",
        tags: "Tags",
        like: "Thích",
        comment: "Bình luận",
        image_video: "Ảnh/Video/Tài liệu",
        emotion: "Cảm xúc",
        done: "Đã làm",
        view: "Xem",
        copyLink:"Sao chép link"
    },
    exercise: {
        essayQuestion: "Bài tập Tự Luận",
        quizQuestion: "Bài tập Trắc Nghiệm",
        name: "Tên bài tập",
        subject: "Chủ đề",
        dueDate: "Ngày đến hạn",
        effectiveDate: "Ngày hiệu lực",
        markScale: "Thang điểm",
        content: "Nhập trực tiếp nội dung bài tập của bạn tại đây, hoặc đăng file từ các nguồn phía dưới",
        fromLocal: "Tải lên từ máy",
        fromLibrary: "Từ thư viện",
        fromWarehouse: "Từ kho đề",
        questionBank: "Ngân hàng câu hỏi",
        numberOfQuiz: "Số câu hỏi",
        answer: "Đáp án",
        hardLevel: "Mức độ khó",
        questionTime: "Thời gian làm bài",
        answerFile: "Tệp đáp án",
        doExercise: "Làm bài",
        title: "Bài làm",
        result: "Kết quả",
        report: "Báo cáo",
        mark: "Điểm",
        comment: "Nhận xét",
        teacherComment: "Nhận xét bài tập",
        teacherCommentImprove: "Nhận xét thái độ học tập",
        returnExercise: "Trả bài",
        student: "Học viên",
        endTime: "Thời gian nộp",
        doing: "Đang làm",
        sent: "Đã nộp",
        marked: "Đã chấm",
        returned: "Đã trả bài",
        uploadResultFile: "File kết quả",
        receivers: "Giao cho",
        questionInStore: "SỬ DỤNG KHO ĐỀ YOLEARN",
        term: "Kì",
        examType: "Loại bài kiểm tra",
        chapter: "Chương",
        lesson: "Bài học",
        viewAnswer: "Xem lời giải"
    },
    notification: {
        title: "Thông báo",
        notifyEmpty: "Bạn không có thông báo nào",
        loadAll: "Xem tất cả"
    },
    userlog: {
        title: "Log người dùng",
        userName: "Người dùng",
        feature: "Chức năng",
        description: "Mô tả",
        createFrom: "Từ ngày",
        createTo: "Đến ngày"
    },
    account: {
        approve: "Phê duyệt",
        approveYocoin: "Xác nhận nạp Yoccoin",
        manage: "Quản lý nạp Yocoin",
        userName: "Người thanh toán",
        addYocoin: "Nạp YoCoin",
        amount: "Số tiền",
        amountYocoin: "Số Yocoin",
        yocoin: "Số Yocoin",
        pay: "Thanh toán"
    },
    procedure:{
        title:"Quản lý thủ tục",
        createForm:"Thêm mới/Sửa Thủ tục",
        name:"Tên thủ tục",
        code:"Mã thủ tục",
        area:"Lĩnh vực",
        config:"Cấu hình",
        fee:"Phí",
        documentOfFile:"Tài liệu hồ sơ",
        documentOfTask:"Tài liệu theo các bước",
        documentTemplate:"Mãu tài liệu",
        documentCode:"Mã tài liệu",
        documentName:"Tên tài liệu",
        taskName:"Công việc",
        mailTemplate:"Mẫu email",
        feeName:"Tên phí",
        feeType:"Loại phí",
        unit:"Đơn vị tính",
        price:"Đơn giá",
        nofee:"Không tính phí",
        start:"Tạo hồ sơ",
        officialFee:"Official",
        attorneyFee:"Attorney",
    },
    $vuetify: {
        dataIterator: {
            rowsPerPageText: "Số mục trên trang:",
            rowsPerPageAll: "Tất cả",
            pageText: "{0}-{1} của {2}",
            noResultsText: "Không tìm thấy bản ghi phù hợp",
            nextPage: "Trang tiếp",
            prevPage: "Trang trước"
        },
        dataTable: {
            rowsPerPageText: "Số dòng trên trang:"
        },
        noDataText: "Không có dữ liệu"
    },
    customer:{
        customerGeneral: "Thông tin chung về khách hàng",
        customerForm: "Danh sách khách hàng",
        customerName: "Tên khách hàng",
        email: "Email",
        contact: "Đầu mối liên hệ",
        agentAddress: "Địa chỉ khách hàng",
        code: "Mã khách hàng",
        phone: "Số điện thoại",
        customerType: "Loại",
        language: "Ngôn ngữ",
        action:"Thao tác",
        createCustomer : "Tạo mới khách hàng",
        country : "Nước",
        manageId : "Người quản lý",
        discount : "Chiết khấu",

    },
    customerRepresent:{
        formName: "Đơn vị đại diện",
        representFullName: "Tên người đại diện",
        representEmail: "Email người đại diện",
        phone: "Số điện thoại",
        roleName: "Chức vụ",
    },
    customerDocument:{
        formName: "Tài liệu",
        createformName: "Tạo mới tài liệu",
        documentCode: "Loại tài liệu",
        documentName: "Tên tài liệu",
    },
    request:{
        subject : "Tiêu đề",
        content : "Nội dung",
        manageId: "Người quản lý",
        customerId : "Khách hàng",
        customerRef: "Số tham chiếu",
        fromEmail: "Email khách hàng",
        deleted:"Đã xóa",
        waiting:"Chờ xử lý",
        assigned:"Đã phân công",
        filed:"Đã tạo hồ sơ",
        done:"Đã hoàn thành",
        cancelRequest:"Hủy phiếu"
    },
    files:{
        titleCreate: "Tạo hồ sơ",
        viewFile:"Xem hồ sơ",
        procedureId: "Thủ tục",
        customerId : "Mã khách hàng",
        manageId: "Người phụ trách",
        customerRef: "Mã tham chiếu",
        title: "Danh sách hồ sơ",
        add: "Thêm mới",
        edit: "Cập nhật",
        appliantForm: "Danh sách chủ đơn",
        applicant: "Chủ đơn",
        applicantAddress: "Địa chỉ",
        clazzForm: "Danh sách class",
        clazz: "Clazz",
        listOfGoodEn: "Danh sách sản phẩm (EN)",
        listOfGoodVi: "Danh sách sản phẩm (VI)",
        numberOfGood: "Số lượng sản phẩm",
        validate_fail_listOfGood: "Số lượng sản phẩm tiếng Anh khác số lượng sản phâm tiếng Việt",
        fileattachsForm: "Danh sách file đính kèm",
        attachTypeId: "Loại đính kèm",
        attachCode: "Mã file",
        attachName: "Tên file",
        attachId: "File đính kèm",
        registerCountryId: "Nước đăng ký",
        ourFile: "Mã hồ sơ",
        agentAddress: "Địa chỉ",
        contact: "Đầu mối liên hệ",
        email: "Email",
        checkId: "Người kiểm tra",
        trademark: "Trademark",
        sampleOfTrademark: "sampleOfTrademark",
        color: "Màu sắc",
        yourFile: "yourFile",

        note: "Ghi chú",
        searchPrefilling:"searchPrefilling",
        disclaimer: "disclaimer",
        priorityDate: "Ngày ưu tiên",
        priorityNo: "Số ưu tiên",
        countryId: "Nước ưu tiên",
        attach: "File đính kèm",
        poaAttach: "Tài liệu POA",
        poaNumber: "Số đơn",
        feeCalculate:"Tính phí",
        document:"Soạn công văn",
        composeEmail:"Soạn thư",
        numberOfObject:"Số đối tượng tính phí",
        total:"Tổng"
    },
    fee:{
        description:"Mô tả",
        amount:"Tổng số",
        official:"Chính thức",
        attorney:"Luật sư",
        subtotal:"Tổng phụ",
        discount:"Giám giá",
        tax:"Thuế",
        bankCharge:"Intermediate bank charge",
        total:"Tổng"
    },

    procedureWh:{
        feedDay: "Số ngày nuôi",
        shrimpReleaseDay: "Ngày thả tôm",
        pondTreatmentDay: "Ngày xử lý ao nuôi",
        shrimpTransferDay: "Ngày sang tôm",
        numberG: "Chọn G",
        viewProcedure: "Xem quy trình",
        typeId: "Nhóm vật tư",
        materialId: "Tên vật tư",
    },

    pond: {
        name: "Ao",
        duplicateName: "Trùng tên ao",
        duplicateCode: "Trùng mã ao"
    },

    area: {
        name:"Khu",
    },
    partner: {
        duplicatePartnerTax: "Trùng mã số thuế",
        duplicatePartnerCode: "Trùng mã đối tượng",
    },
    pondArea: {
        duplicateName: "Trùng tên khu",
        duplicateCode: "Trùng mã khu",
        duplicateSymbol: "Trùng ký hiệu khu",
    },
    materialTypeGroup: {
        duplicateName: "Trùng tên ",
        duplicateCode: "Trùng mã ",
    },
    pondType: {
        duplicateName: "Trùng tên loại ao",
        duplicateSymbol: "Trùng ký hiệu loại ao",
    },
    crop:{
        name:"Vụ",
        cropNo: "Số thứ tự",
        year: "Vụ của năm"
    },
    material: {
        code:"Mã vật tư",
        duplicateCode: "Trùng mã vật tư",
        materialType: "Nhóm vật tư",
    },
    seedNumber:{
        duplicateCode: "Trùng Số lượng con giống",
        duplicateName: "Trùng tên",
    },
    fixedAssets:{
        duplicateCode: "Trùng mã tài sản",
    },
    officeLocation:{
        duplicateName: "Trùng tên",
    },
    envMeasure: {
        date: "Ngày",
        session: "Buổi",
        note: "Ghi chú",
        am: "Sáng",
        pm: "Chiều"
    },
    purchase:{
        create:"Tạo phiếu",
        createNew:"Tạo ĐNMH Mới",
        deliverDate:"Ngày giao hàng đề xuất",
        buyNumber:"Số lượng cần mua",
        buyNumberPropose:"Số lượng đề xuất mua",
        actualImport:"Tổng số lượng thực nhập",
        buyAdditionNumber:"Số lượng bổ sung",
        price:"Đơn giá",
        money:"Thành tiền",
        vendor:"Nhà cung cấp",
        reserved:"Dự phòng",
        totalByProcess:"Số lượng theo quy trình",
        remain:"Tồn kho",
        unit:"Đơn vị",
        pack:"Đóng gói",
        material:"Tên vật tư",
        purpose:"Mục đích sử dụng"
    },
    exportRequest:{
        requestDate: "Ngày xuất kho yêu cầu",
    },
    report:{
        warehouse:"Kho",
        form:"Form",
        print:"In báo cáo",
        send:"Gửi báo cáo",
        type: "Loại báo cáo",
    },
    school:{
        className : "Tên lớp",
        ageId : "Độ tuổi",
        classAccount: "Tài khoản",
        classPassword: "Mật khẩu",
        levelStartId: "Level bắt đầu",
        numberStudent: "Sĩ số",
        oldPassword: "Mật khẩu hiện tại của bạn",
        password: "Mật khẩu mới của bạn",
        confirmPassword: "Nhập lại mật khẩu mới của bạn",
        password_not_match : "Mật khẩu không khớp"
    }
};
